import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import HelloWorld from '../components/HelloWorld.vue'
import ApiService from '../views/ApiService.vue'
import Articles from '../views/Articles.vue'
import NotFound from '../views/NotFound.vue'
import Technology from '../views/Technology.vue'
import Community from '../views/Community.vue'
import Ranking from '../views/Ranking.vue'
import VoteList from '../views/vote/VoteList.vue'
import VoteDetail from '../views/vote/VoteDetail.vue'
import CreateVote from '../views/vote/CreateVote.vue'
import Tools from '@/views/Tools.vue'
import JsonFormatter from '@/views/tools/JsonFormatter.vue'
import TimestampConverter from '@/views/tools/TimestampConverter.vue'
import Base64Tool from '@/views/tools/Base64Tool.vue'
import UrlEncoder from '@/views/tools/UrlEncoder.vue'
import Md5Tool from '@/views/tools/Md5Tool.vue'
import QrcodeTool from '@/views/tools/QrcodeTool.vue'
import ColorConverter from '@/views/tools/ColorConverter.vue'
import RegexTester from '@/views/tools/RegexTester.vue'
import PasswordGenerator from '@/views/tools/PasswordGenerator.vue'
import UuidGenerator from '@/views/tools/UuidGenerator.vue'
import PinyinConverter from '@/views/tools/PinyinConverter.vue'
import TextDiff from '@/views/tools/TextDiff.vue'
import CronExpression from '@/views/tools/CronExpression.vue'
import ImageCompress from '@/views/tools/ImageCompress.vue'
import JsBeautify from '@/views/tools/JsBeautify.vue'
import WordCount from '@/views/tools/WordCount.vue'
import BaseConverter from '@/views/tools/BaseConverter.vue'
import VolumeConverter from '@/views/tools/VolumeConverter.vue'




const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/drama',  // 添加新路由
        name: 'drama',
        component: HelloWorld
    },
    {
        path: '/api',
        name: 'api',
        component: ApiService
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: NotFound
    },
    {
        path: '/articles',
        name: 'articles',
        component: Articles
    },
    {
        path: '/tech',
        name: 'tech',
        component: Technology
    },
    {
        path: '/community',
        name: 'community',
        component: Community
    },
    {
        path: '/ranking',
        name: 'ranking',
        component: Ranking
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/LoginView.vue')
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('@/views/ProfileView.vue'),
        meta: {requiresAuth: true}
    },
    {
        path: '/votes',
        name: 'votes',
        component: VoteList
    },
    {
        path: '/votes/create',
        name: 'createVote',
        component: CreateVote,
        meta: {requiresAuth: true}
    },
    {
        path: '/votes/:id',
        name: 'voteDetail',
        component: VoteDetail
    },
    {
        path: '/tools',
        name: 'tools',
        component: Tools,
        meta: {
            title: '常用工具'
        }
    },
    {
        path: '/tools/json',
        name: 'json-formatter',
        component: JsonFormatter,
        meta: {
            title: 'JSON格式化'
        }
    },
    {
        path: '/tools/timestamp',
        name: 'timestamp-converter',
        component: TimestampConverter,
        meta: {
            title: '时间戳转换'
        }
    },
    {
        path: '/tools/base64',
        name: 'base64-tool',
        component: Base64Tool,
        meta: { title: 'Base64编解码' }
    },
    {
        path: '/tools/url',
        name: 'url-encoder',
        component: UrlEncoder,
        meta: { title: 'URL编解码' }
    },
    {
        path: '/tools/md5',
        name: 'md5-tool',
        component: Md5Tool,
        meta: { title: 'MD5加密' }
    },
    {
        path: '/tools/qrcode',
        name: 'qrcode-tool',
        component: QrcodeTool,
        meta: { title: '二维码生成' }
    },
    {
        path: '/tools/color',
        name: 'color-converter',
        component: ColorConverter,
        meta: { title: '颜色转换' }
    },
    {
        path: '/tools/regex',
        name: 'regex-tester',
        component: RegexTester,
        meta: { title: '正则测试' }
    },
    {
        path: '/tools/password',
        name: 'password-generator',
        component: PasswordGenerator,
        meta: { title: '密码生成器' }
    },
    {
        path: '/tools/uuid',
        name: 'uuid-generator',
        component: UuidGenerator,
        meta: { title: 'UUID生成器' }
    },
    {
        path: '/tools/pinyin',
        name: 'pinyin-converter',
        component: PinyinConverter,
        meta: { title: '汉字转拼音' }
    },
    {
        path: '/tools/diff',
        name: 'text-diff',
        component: TextDiff,
        meta: { title: '文本比较' }
    },
    {
        path: '/tools/cron',
        name: 'cron-expression',
        component: CronExpression,
        meta: { title: 'Cron表达式' }
    },
    {
        path: '/tools/regex',
        name: 'regex-tester',
        component: RegexTester,
        meta: { title: '正则表达式' }
    },
    {
        path: '/tools/image-compress',
        name: 'image-compress',
        component: ImageCompress,
        meta: { title: '图片压缩工具' }
    },
    {
        path: '/tools/js-beautify',
        name: 'js-beautify',
        component: JsBeautify,
        meta: { title: 'JavaScript 代码美化工具' }
    },
    {
        path: '/tools/word-count',
        name: 'word-count',
        component: WordCount,
        meta: { title: '字数统计' }
    },
    {
        path: '/tools/base-converter',
        name: 'base-converter',
        component: BaseConverter,
        meta: { title: '进制转换' }
    },
    {
        path: '/tools/password-gen',
        name: 'password-gen',
        component: PasswordGenerator,
        meta: { title: '密码生成器' }
    },
    {
        path: '/tools/uuid-gen',
        name: 'uuid-gen',
        component: UuidGenerator,
        meta: { title: 'UUID生成器' }
    },
    {
        path: '/tools/text-diff',
        name: 'text-diff',
        component: TextDiff,
        meta: { title: '文本比较工具' }
    },
    {
        path: '/tools/random-number',
        name: 'RandomNumber',
        component: () => import('@/views/tools/RandomNumber.vue'),
        meta: {
            title: '随机数生成'
        }
    },
    {
        path: '/tools/bmi',
        name: 'BmiCalculator',
        component: () => import('@/views/tools/BmiCalculator.vue'),
        meta: {
            title: 'BMI计算器'
        }
    },
    {
        path: '/tools/weight-converter',
        name: 'WeightConverter',
        component: () => import('@/views/tools/WeightConverter.vue'),
        meta: {
            title: '重量换算'
        }
    },
    {
        path: '/tools/volume-converter',
        name: 'volume-converter',
        component: VolumeConverter,
        meta: { title: '体积换算' }
    },
    {
        path: '/tools/time-converter',
        name: 'TimeConverter',
        component: () => import('@/views/tools/TimeConverter.vue'),
        meta: {
            title: '时间换算'
        }
    },
    {
        path: '/tools/storage-converter',
        name: 'StorageConverter',
        component: () => import('@/views/tools/StorageConverter.vue'),
        meta: {
            title: '存储换算'
        }
    },
    {
        path: '/tools/speed-converter',
        name: 'SpeedConverter',
        component: () => import('@/views/tools/SpeedConverter.vue'),
        meta: {
            title: '速度换算'
        }
    },
    {
        path: '/tools/pressure-converter',
        name: 'PressureConverter',
        component: () => import('@/views/tools/PressureConverter.vue'),
        meta: {
            title: '压力换算'
        }
    },
    {
        path: '/tools/length-converter',
        name: 'LengthConverter',
        component: () => import('@/views/tools/LengthConverter.vue'),
        meta: {
            title: '长度换算'
        }
    },
    {
        path: '/tools/force-converter',
        name: 'ForceConverter',
        component: () => import('@/views/tools/ForceConverter.vue'),
        meta: {
            title: '力换算'
        }
    },
    {
        path: '/tools/density-converter',
        name: 'DensityConverter',
        component: () => import('@/views/tools/DensityConverter.vue'),
        meta: {
            title: '密度换算'
        }
    },
    {
        path: '/tools/area-converter',
        name: 'AreaConverter',
        component: () => import('@/views/tools/AreaConverter.vue'),
        meta: {
            title: '面积换算'
        }
    },
    {
        path: '/tools/power-converter',
        name: 'PowerConverter',
        component: () => import('@/views/tools/PowerConverter.vue'),
        meta: {
            title: '功率换算'
        }
    },
    {
        path: '/tools/temperature-converter',
        name: 'TemperatureConverter',
        component: () => import('@/views/tools/TemperatureConverter.vue'),
        meta: {
            title: '温度换算'
        }
    },
    {
        path: '/tools/relationship-calculator',
        name: 'RelationshipCalculator',
        component: () => import('@/views/tools/RelationshipCalculator.vue'),
        meta: {
            title: '亲戚称谓计算器'
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
